import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'
import App from './App'
import ErrorBoundary from './app/components/errors/ErrorBoundary'
import { SecondaryNavProvider } from './app/components/SecondaryNav/SecondaryNavProvider'
import ServiceWorkerErrorBoundary from './app/components/ServiceWorkerErrorBoundary'
import UpdateGuard from './app/guards/UpdateGuard'
import { DarkModeProvider } from './app/providers/DarkModeProvider'
import { UserProvider } from './app/providers/UserProvider'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import '@cyntler/react-doc-viewer/dist/index.css'
import './index.css'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
)

root.render(
  <HelmetProvider>
    <QueryClientProvider client={new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: true,
          retry: false,
          // staleTime: 1000 * 60 * 5,
        },
      },
    })}
    >
      <BrowserRouter>
        <React.StrictMode>
          <ServiceWorkerErrorBoundary>
            <DarkModeProvider>
              <UpdateGuard>
                <UserProvider>
                  <SecondaryNavProvider>
                    <ErrorBoundary>
                      <App />
                    </ErrorBoundary>
                  </SecondaryNavProvider>
                </UserProvider>
              </UpdateGuard>
            </DarkModeProvider>
          </ServiceWorkerErrorBoundary>
        </React.StrictMode>
      </BrowserRouter>
    </QueryClientProvider>
    <ToastContainer pauseOnFocusLoss={false} />
  </HelmetProvider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (_registration) => {
    // When an update is found, don't auto-update
    // Let the UpdateGuard handle it
  },
  onSuccess: () => {
    // Service worker registered successfully
  },
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
